import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { storedLength } from '../../utils/text-length';

/**
 * Live "N / max characters" counter for text inputs bound to a length-limited Dataverse column.
 *
 * Counts the way the API will receive the value (line breaks as CRLF), so the number shown here is
 * the number the platform enforces - see `storedLength`.
 *
 * Usage: <app-char-counter [control]="form.get('applicationDescription')" [max]="4000">
 */
@Component({
  selector: 'app-char-counter',
  template: `
    <small class="form-text" [ngClass]="length > max ? 'text-danger' : 'text-muted'">
      {{ length }} / {{ max }} characters
    </small>
  `,
})
export class CharCounterComponent {
  @Input() control: AbstractControl | null = null;
  @Input() max: number = 0;

  /**
   * Characters charged per line break: 2 for a multipart/form-data page (the default), 1 for a page
   * that posts JSON. See `storedLength`.
   */
  @Input() lineBreakCost: number = 2;

  get length(): number {
    return storedLength(this.control?.value, this.lineBreakCost);
  }
}
